import action from '../helpers/rest-client';
import { SearchOutDto } from '../types/search.dto';

class Search {
  public async search({ group_id, q }: SearchOutDto) {
    return action
      .Get({
        url: `/api/search?group_id=${group_id}&q=${encodeURIComponent(q)}`,
      })
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }
}

const search = new Search();
export default search;
